(ns common.error-page.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.error-page.error-image :refer [error-image no-access-image]]
            [common.widgets.page :as page]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]))

(def possible-errors
  {"not_found_error"
   {:title "Not Found"
    :text #(str "Unfortunately the requested " % " does not exist or you do not have access for it.")
    :image error-image}

   "not_authorized_error"
   {:title "Not Allowed"
    :text (str "Unfortunately you do not have sufficient rights in order to proceed.\n"
               "Please verify your access rights with your account administrator.")
    :image error-image}

   "studio_not_authorized_error"
   {:title "Not Authorized"
    :text (str "Unfortunately you do not have sufficient rights in order to proceed.\n"
               "Please log into an account with sufficient rights for this adset preview.")
    :image error-image}

   "os_workspace_mapping_missing"
   {:title "This tenant is not enabled yet"
    :text "Unfortunately this tenant is not onboarded yet, please contact our support to enabled this for you."
    :image no-access-image}

   "os_workspace_mapping_missing_demo_available"
   {:title "We are almost ready to enable your app"
    :text "You can create a demo account to get started, or request that an admin links you to existing advertiser."
    :image no-access-image}})

(defui error-page
  [{:keys [entity-name code appbar button button-label button-event sidebar error-message buttons]
    :or {entity-name ""
         code "not_authorized_error"
         appbar true
         sidebar true
         button true
         button-event [:router/navigate-home]
         button-label "Back to Home!"
         buttons nil}}]
  (let [current-error (possible-errors code)
        page-title (:title current-error)
        error-text (or error-message (:text current-error))
        image (:image current-error)
        title (get current-error :title "Whoops, it looks like something went wrong!")
        text (if (fn? error-text)
               (error-text entity-name)
               error-text)]
    ($ page/page
       {:title (str page-title " | Creative Optimizations")
        :appbar appbar
        :sidebar sidebar}
       ($ page/content-padding
          ($ Stack
             {:alignItems "center"
              :spacing 2
              :sx #js {:mt 8}}
             ($ image)
             ($ Typography
                {:variant "h2"
                 :weight "semibold"}
                title)
             ($ :span {:style {:display "inline-block" :white-space "pre-line" :text-align "center"}} text)
             (cond
               buttons buttons
               button ($ Button
                         {:variant "contained"
                          :on-click #(rf/dispatch button-event)}
                         button-label)))))))
